import { omit } from "lodash";

import type { Appointment } from "services/types/appointments.type";
import type {
  AppointmentBlock,
  PersonalEvent
} from "services/types/events.type";

/**
 * Recurrence fields must never carry over into a newly created event
 * (reschedule / duplicate seeds spread the source appointment): a leaked
 * `schedule`/`rrule` on POST makes the backend attach a Schedule and
 * silently generate an entire recurring series (SN-18585).
 */
const RECURRENCE_CARRYOVER_FIELDS = [
  "schedule",
  "rrule",
  "recurrencePeriod",
  "recurrenceDay",
  "recurrenceWeek",
  "endRecurrenceDate"
] satisfies (
  | keyof Appointment
  | keyof PersonalEvent
  | keyof AppointmentBlock
)[];

export const stripRecurrenceCarryover = <T extends object>(event: T): T =>
  omit(event, RECURRENCE_CARRYOVER_FIELDS) as T;
